import { gql } from '@apollo/client';

export interface DeleteOrganizationNoteRequest {
  id: string;
}

export interface DeleteOrganizationNoteResponse {
  deleteOrganizationNote: boolean;
}

export const DELETE_ORGANIZATION_NOTE = gql`
  mutation DeleteOrganizationNote($id: String!) {
    deleteOrganizationNote(id: $id)
  }
`;
